<template>
  <div class="sidebar" :class="{ 'sidebar--collapsed': collapsed }">
    <div class="sidebar__logo"></div>
    <div class="sidebar__overlay"></div>
    <div class="sidebar__menu" v-clickoutside="hideSidebarOutclicked">
      <SidebarMenu
        style="margin-bottom: 0px"
        :menu="[
          {
            icon: 'home',
            moduleURL: '',
            name: 'Dashboard',
            child: null,
          },
        ]"
      />
      <SidebarMenu :menu="menu" style="margin-top: 0px" />
    </div>
  </div>
</template>

<script>
import ApiClient from '../utils/ApiClient';
import SidebarMenu from './SidebarMenu.vue';

export default {
  name: 'Sidebar',
  data() {
    return {
      collapsed: false,
      module: process.env.VUE_APP_PROJECT,
      menu: [],
    };
  },
  components: {
    SidebarMenu,
  },
  mounted() {
    this.$root.$on('collapse', (state) => {
      this.toggleSidebar(state);
    });

    if (this.collapsed) {
      document.body.classList.add('pw-dashboard--collapsed');
    }
    this.getMenu();
    this.$root.$on('reloadClaims', this.getMenu);
  },
  methods: {
    getMenu() {
      if (this.module !== 'WA') {
        const apiClient = new ApiClient(`sidebar/GetMenu/${this.module}`, 'common');
        apiClient.Get().then((data) => {
          this.menu = data;
        });
      }
    },
    hideSidebar() {
      this.collapsed = false;
      this.toggleSidebar(false);
    },
    hideSidebarOutclicked(event) {
      if (
        this.collapsed === true &&
        !event.target.parentElement.className.includes('pw-navbar__expander')
      ) {
        this.hideSidebar();
      }
    },
    toggleSidebar(state) {
      let collapsed = state;
      if (collapsed && document.body.classList.contains('pw-dashboard--collapsed')) {
        collapsed = false;
        document.body.classList.remove('pw-dashboard--collapsed');
      }
      if (collapsed) {
        document.body.classList.add('pw-dashboard--collapsed');
      } else {
        document.body.classList.remove('pw-dashboard--collapsed');
      }
      this.collapsed = collapsed;
    },
  },
};
</script>

<style lang="scss" scoped>
@media all and (max-width: 768px) {
  .sidebar {
    z-index: 998 !important;
    transform: translateX(-100%);
    &.sidebar--collapsed {
      transform: translateX(0%);

      .sidebar__logo {
        overflow: auto;
        svg {
          transform: none !important;
          .blue-in-collapse {
            fill: white;
          }
        }
      }
    }
    &__overlay {
      top: 0px !important;
    }
  }
}

.sidebar__overlay {
  position: fixed;
  top: 55px;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: 1000001;
  display: none;
  background: rgba(120, 120, 120, 0.5);
}
.sidebar.sidebar--collapsed {
  //width: 50px;
  pointer-events: all;
  z-index: 10000002;
  .sidebar__overlay {
    display: block;
  }
  .sidebar__menu {
    transform: translateX(0);
  }
  .sidebar__logo {
    transform: translateX(0);
  }
}
.sidebar {
  transition: width 0.3s ease-in-out;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 55px;
  left: 0;
  height: 100%;
  z-index: 1000002;
  pointer-events: none;
  &__menu {
    height: 100% !important;
    overflow: auto;
    z-index: 100001000;
    position: relative;
    width: 250px;
    background-color: #fff;
    transform: translateX(-100%);
    transition: all 0.3s;
    //box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.16);
  }
  &__logo {
    transform: translateX(-100%);
    transition: all 0.3s;
    background-color: #f5f5f5;
    height: 55px;
    display: none;
    align-items: center;
    justify-content: center;
    transition: none;
    z-index: 100001000;
    position: relative;
    width: 250px;
    a {
      width: 175px;
      display: block;
      text-align: center;
    }
    svg {
      width: 175px;
      fill: #fff;
      transition: all 0.2 ease-in-out;
      transition-delay: 0.2;
      transform: 0;
    }
  }
}
</style>
